export default __webpack_public_path__ + "static/media/C26AAA0D-73FF-4532-9F79-E37B295A67F7-Pallavi-Rohatgi.7da38695.jpeg";